<template>
  <div class="signup">
    <auth-container writerType="imps">
      <sign-up-form />
    </auth-container>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import SignUpForm from "@/components/organisms/SignUpForm.vue";
import AuthContainer from "@/components/organisms/AuthContainer.vue";
import { checkDeprecatedBrowser } from "@/lib/checkDeprecatedBrowser";

export default Vue.extend({
  // NOTE: metaタグの設定
  metaInfo() {
    const meta = process.env.NODE_ENV !== "production" ? [{ name: "robots", content: "none" }] : [];
    return {
      title: this.$t("app.meta.signUpTitle") as string,
      titleTemplate: "%s",
      meta: [
        ...meta,
        { vmid: "description", name: "description", content: this.$t("app.meta.signUpDescription") as string },
        { vmid: "og:title", property: "og:title", content: this.$t("app.meta.signUpTitle") as string },
        {
          vmid: "og:description",
          property: "og:description",
          content: this.$t("app.meta.signUpDescription") as string,
        },
        { vmid: "og:url", property: "og:url", content: window.location.href },
      ],
    };
  },
  components: {
    SignUpForm,
    AuthContainer,
  },
  created() {
    /** 非推奨ブラウザへの文言表示 */
    checkDeprecatedBrowser();
  },
});
</script>

<style lang="scss" scoped>
.signup {
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 0;
}
</style>
